import { enumMapToSelectOptions } from '@/utils/misc.ts';

export enum Currency {
  USD = 'USD',
  HKD = 'HKD',
  CNY = 'CNY',
  SGD = 'SGD',
  JPY = 'JPY',
  KRW = 'KRW',
  AUD = 'AUD',
  TWD = 'TWD',
}

export const currencies = Object.keys(Currency) as Currency[]

export const currenciesAntd: Record<string, string> = Object.keys(Currency).reduce((acc, key) => {
  acc[key] = Currency[key as keyof typeof Currency]
  return acc
}, {} as Record<string, string>)

export const currencyOptions = enumMapToSelectOptions(currenciesAntd)

export enum Region {
  Global,
  HongKong,
  China,
  Taiwan,
  Japan,
  Korea,
  Singapore,
  Australia,
  UnitedStates
}

export const regionAbbrMapping: Record<string, string> = {
  [Region.HongKong]: 'hk',
  [Region.China]: 'cn',
  [Region.Taiwan]: 'tw',
  [Region.Japan]: 'jp',
  [Region.Korea]: 'kr',
  [Region.Singapore]: 'sg',
  [Region.Australia]: 'au',
  [Region.UnitedStates]: 'us',
  [Region.Global]: '',
}

export const regionLocalCurrencyMapping: Record<string, Currency> = {
  [Region.HongKong]: Currency.HKD,
  [Region.China]: Currency.CNY,
  [Region.Taiwan]: Currency.TWD,
  [Region.Japan]: Currency.JPY,
  [Region.Korea]: Currency.KRW,
  [Region.Singapore]: Currency.SGD,
  [Region.Australia]: Currency.AUD,
  [Region.UnitedStates]: Currency.USD,
}

export const regionCityOptionsMapping: Record<string, string[]> = {
  [Region.HongKong]: [],
  [Region.China]: ['Shanghai', 'Beijing'],
  [Region.Taiwan]: [],
  [Region.Japan]: [],
  [Region.Korea]: [],
  [Region.Singapore]: [],
  [Region.Australia]: [],
  [Region.UnitedStates]: [],
}

export const regionCnCityOptionsMapping: Record<string, string[]> = {
  [Region.HongKong]: [],
  [Region.China]: ['上海', '北京'],
  [Region.Taiwan]: [],
  [Region.Japan]: [],
  [Region.Korea]: [],
  [Region.Singapore]: [],
  [Region.Australia]: [],
  [Region.UnitedStates]: [],
}
